import { BehaviorSubject } from "rxjs";

const isLoading$ = new BehaviorSubject(true);

export default isLoading$;
